// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.authenticated-student.warning{color:#d1002a}`, "",{"version":3,"sources":["webpack://./assets/src/scripts/components/authenticated-student-warning-message.vue","webpack://./assets/src/styles/config/_colors.scss"],"names":[],"mappings":"AAGC,+BACC,aCGM","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
